import { type Location } from 'react-router-dom';

/**
 * Appends the current location as a `target` query param to a sign-in path so that
 * `ValidationResponder.forwardToTargetUrl` can return the user to where they were
 * headed once they authenticate. Without this, a logged-out user who deep-links to a
 * protected route is sent to the dashboard after signing in instead of their original
 * destination.
 */
export function buildSignInPathWithTarget(signInPath: string, location: Pick<Location, 'pathname' | 'search'>) {
    const target = encodeURIComponent(`${location.pathname}${location.search}`);
    return `${signInPath}?target=${target}`;
}
